import v39Schema from "../client/schemaVersions/v39.js";
import v40Schema from "../client/schemaVersions/v40.js";
import { createMigration } from "@verdant-web/store";
export default createMigration(v39Schema, v40Schema, async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
});
//# sourceMappingURL=v40.js.map